import type { SavedProjectView, SavedProjectViewVisibility, ViewMode } from '@/types';
import { api } from './client';

export interface CreateSavedProjectViewInput {
  name: string;
  view_type: ViewMode;
  filters?: Record<string, unknown>;
  sort?: unknown[];
  group?: Record<string, unknown> | null;
  columns?: unknown[];
  visibility?: SavedProjectViewVisibility;
  is_favorite?: boolean;
  is_default?: boolean;
}

export type UpdateSavedProjectViewInput = Partial<CreateSavedProjectViewInput>;

export const projectViewsApi = {
  getAll: (projectId: string) =>
    api.get<{ views: SavedProjectView[] }>(`/projects/${projectId}/views`),

  getById: (projectId: string, viewId: string) =>
    api.get<{ view: SavedProjectView }>(`/projects/${projectId}/views/${viewId}`),

  create: (projectId: string, data: CreateSavedProjectViewInput) =>
    api.post<{ view: SavedProjectView }>(`/projects/${projectId}/views`, data),

  update: (projectId: string, viewId: string, data: UpdateSavedProjectViewInput) =>
    api.patch<{ view: SavedProjectView }>(`/projects/${projectId}/views/${viewId}`, data),

  delete: (projectId: string, viewId: string) =>
    api.delete<{ message: string }>(`/projects/${projectId}/views/${viewId}`),
};
